import axios from "../axios"
import apiUrls from "../urls"
// import { jsonp } from 'vue-jsonp'

export default {
    refereeLogin (data) {
        return axios.post(apiUrls.refereeLogin, data)
    },
    refereeSubmit (data) {
        return axios.post(apiUrls.refereeSubmit, data, {
            headers: {
                "Authorization": "Bearer " + data.refereeToken
            },
        })
    }
}
